import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "summary-line o-text-caption" }
const _hoisted_2 = {
  key: 0,
  class: "summary-line o-text-caption"
}

import { computed, ComputedRef } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import offersStore from '@/b2c/offers/offers.store';
import {
    PersonalOfferViewModel,
} from '@/b2c/shared/api/server-apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferSummaryTaxes',
  props: {
    salesTax: null
  },
  setup(__props: any) {



const labels = useBlockLabels();

const offer: ComputedRef<PersonalOfferViewModel> = computed(() => {
    return offersStore.detail;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dl", _hoisted_1, [
      _createElementVNode("dt", null, _toDisplayString(_unref(labels).summaryTax), 1),
      _createElementVNode("dd", null, _toDisplayString(__props.salesTax), 1)
    ]),
    (_unref(offer).totalEcoTax)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_2, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$dictionary.get('b2c/productDetailItem/ecoTax')), 1),
          _createElementVNode("dd", null, _toDisplayString(_unref(offer).totalEcoTax), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})